import { IRequest } from '@r1-frontend/shared/types/IRequest';
export type { ISeasonTicketPaySum } from './dto/ResponseDto';

/**
 * Получить сумму к оплате при подключении абонемента
 * https://master.api-season-ticket.sandbox.d2c.r-one.io/docs/#/season-ticket/SeasonTicketController_getPaySum
 * @returns ISeasonTicketPaySum
 */
export const seasonTicketPaySum = (providerId: number, flagId: number): IRequest => ({
    uri: `/api/v1/${providerId}/season-ticket/${flagId}/pay-sum`,
    method: 'GET',
    withAuth: true,
    withProvider: true,
});
